module.exports = __webpack_public_path__ + "img/cerimoniere.8c961c7b.jpg";